import React, { useState } from "react";
import { useParams, useSearchParams, useNavigate, Link } from "react-router-dom";
import { forgetPassword } from "./albumPassword";
import "./MediaAlbum.css";

const LOGO_URL =
  "https://nbetrdzkoskuwnpbvxvh.supabase.co/storage/v1/object/public/public-assets/keepsake-logo-koala.png";

const FUNCTIONS_BASE =
  process.env.REACT_APP_SUPABASE_FUNCTIONS_URL ||
  `${process.env.REACT_APP_SUPABASE_URL}/functions/v1`;

// Opened from the "reset your album password" email: /a/{slug}/reset?token=...
function ResetPassword() {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const navigate = useNavigate();

  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [linkInvalid, setLinkInvalid] = useState(!token);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    const pw = pw1.trim();
    if (pw.length < 3) return setError("Please use at least 3 characters.");
    if (pw !== pw2.trim()) return setError("The two passwords don't match.");

    setSaving(true);
    try {
      const resp = await fetch(`${FUNCTIONS_BASE}/album_password_reset`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
        },
        body: JSON.stringify({ action: "confirm", slug, token, password: pw }),
      });
      const data = await resp.json().catch(() => ({}));
      if (resp.ok && data.ok) {
        // Back to the password page so they sign in with the new password (any saved old one is dropped).
        forgetPassword(slug);
        navigate(`/a/${slug}`, { replace: true, state: { passwordReset: true } });
        return;
      }
      if (data.error === "invalid_link") setLinkInvalid(true);
      else setError("Sorry, something went wrong. Please try again.");
    } catch (err) {
      console.error("album_password_reset confirm error:", err);
      setError("Sorry, something went wrong. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="album-container album-container--locked">
      <div className="password-gate">
        <div className="password-card">
          <div className="password-logo">
            <img src={LOGO_URL} alt="KeepsakeQR" />
          </div>
          {linkInvalid ? (
            <>
              <h1 className="password-title">This link has expired</h1>
              <p className="password-subtitle">
                Reset links work once and only for an hour. Go back to your album and tap
                “Forgot password?” to get a new one.
              </p>
              <Link className="reset-submit" to={`/a/${slug}`}>
                Back to the album
              </Link>
            </>
          ) : (
            <>
              <h1 className="password-title">Choose a new password</h1>
              <p className="password-subtitle">You'll use this to open your album from now on.</p>
              <form className="reset-form" onSubmit={submit}>
                <input
                  type="password"
                  value={pw1}
                  onChange={(e) => setPw1(e.target.value)}
                  placeholder="New password"
                  autoComplete="new-password"
                  autoFocus
                />
                <input
                  type="password"
                  value={pw2}
                  onChange={(e) => setPw2(e.target.value)}
                  placeholder="Type it again"
                  autoComplete="new-password"
                />
                <button className="reset-submit" type="submit" disabled={saving}>
                  {saving ? "Saving…" : "Save new password"}
                </button>
              </form>
              {error && <p className="password-error">{error}</p>}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
